module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-57x57-793044278911cd3c1e28e4741b0c3179.png";